module.exports = __webpack_public_path__ + "static/media/amanda_mbali.82337ed8.jpeg";